import React, { useEffect, useState, useCallback, useMemo } from 'react';
import {
  Form,
  FormGroup,
  Row,
  Col,
  Container,
  Label,
  Modal,
  ModalBody,
} from 'reactstrap';
import {
  FilterButton,
  SearchInput,
  CommonButton,
  DealerCodeCard,
  SingleSelect,
} from '../../../Components/CommonComponents';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import Pagination from '../../../Components/Pagination/Pagination';
import {
  getDealerSAPDataById,
  getDealerwithStatus,
  getTerritories,
} from '../../../constants/apiCalls';
import lodash from 'lodash';
import excelImg from '../../../images/excel.png';
import { messages } from '../../../utils/constant-messages';
import closeImg from './../../../images/modalclose.png';
import './index.css';
import { DashBoardTitle } from '../../../Components/Title';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import { useNavigate } from 'react-router-dom';
import { Permissions } from '../../../constants/Permissions';
import Storage from '../../../services/Storage';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const AssignDealerCode = () => {

  const navigate = useNavigate();
  // const localPermission = Storage.getUserPermissionDetail();
  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;
  useEffect(() => {
    if (!localPermission.includes(Permissions.ADMIN_ASSIGN_DEALER_CODE)) {
      navigate('/');
    }
  }, [...localPermission])

  let pageNo = useMemo(() => Storage.getAssignDealerCodePage(), [Storage.getAssignDealerCodePage()]);

  const [isLoading, setIsloading] = useState(false);

  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(10);

  const [searchQuery, setSearchQuery] = useState('');
  const [userQuery, setUserQuery] = useState('');

  // Dealer Data on Card
  const [dealerData, setDealerData] = useState([]);

  // Filter Modal
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [territoryData, setTerritoryData] = useState([]);
  const [territoryVal, setTerritoryVal] = useState('');
  const [territoryId, setTerritoryId] = useState('');

  const [show, setShow] = useState(null);
  const [filterbtnActive, setFilterBtnActive] = useState(false);

  const sendQuery = (query) => {
    setSearchQuery(query);
  };
  const delayedQuery = useCallback(
    lodash.debounce((q) => sendQuery(q), 1000),
    []
  );

  useEffect(() => {
    setIsloading(true);
    getDealerListData();
  }, [searchQuery, page, pageSize, territoryId]);

  const getTerritory = () => {
    getTerritories((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setTerritoryData(data);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    });
  };

  const getDealerListData = () => {
    let payload = {
      q: searchQuery,
      page: page || 1,
      pagesize: pageSize || 10,
      type: 'approve',
      start_date: '',
      end_date: '',
      territory_id: territoryId || '',
      adminOnly: true,
      manageDealer: false,
      is_download: false,
      application_upload: false,
    };
    getDealerwithStatus((res) => {
      const { data, success, error } = res;
      if (success === true) {
        if (data && data.data) {
          setDealerData(data.data);
        } else {
          setDealerData([]);
        }
        let count = Number(data.total_count);
        setCount(count);
        let totalPages = Math.ceil(count / pageSize);
        setTotalPages(totalPages);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  // search Functionality
  const handleSearchChange = (e) => {
    let q = e.target.value;
    delayedQuery(q);
    setUserQuery(q);
    if (q) {
      setPage(1);
    } else {
      setPage(Number(pageNo));
    }
  };

  // Excel sheet
  const handleExcelSheet = () => {
    let payload = {
      q: searchQuery,
      page: page || 1,
      pagesize: 1000000,
      type: 'approve',
      start_date: '',
      end_date: '',
      territory_id: territoryId || '',
      adminOnly: true,
      manageDealer: false,
      is_download: true,
      application_upload: false,
    };
    getDealerwithStatus((res) => {
      const { data, success, error } = res;
      if (success === true) {
        window.open(data.file, '_blank');
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setAssignDealerCodePage(Number(page));
    },
    [page, pageSize]
  );

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
    },
    [page, pageSize]
  );

  const handleCardClick = (id) => {
    if (id === show) {
      setShow(null);
    } else {
      setShow(id);
    }
  };

  const handleFilterBtnClick = () => {
    getTerritory();
    setShowFilterModal(!showFilterModal);
    // setTerritoryVal('')
  };

  const handleChangeTerritory = (e) => {
    setTerritoryVal(e.target.value);
  };

  const handleResetFilter = () => {
    setTerritoryVal('');
    setTerritoryId('');
    // getDealerListData();
    setShowFilterModal(false);
    setFilterBtnActive(false);
    setPage(1);
    Storage.setAssignDealerCodePage(1);
  };

  const handleApplyFilter = (e) => {
    e.preventDefault();
    if (territoryVal) {
      setTerritoryId(territoryVal);
      setShowFilterModal(false);
      setFilterBtnActive(true);
      setPage(1);
      Storage.setAssignDealerCodePage(1);
    }
  };

  const handleSAPExcel = (id) => {
    let payload = {
      dealer_id: id
    }
    setIsloading(true);
    getDealerSAPDataById((res) => {
      const { data, success, error } = res;
      if (success === true) {
        window.open(data.file, '_blank');
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  }

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='AssignDealerCode'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='Assign Dealer Code' className="lightTitle" />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <div className='searchArea'>
                        <div className='searchBlock'>
                          <SearchInput
                            InputProps={{
                              name: 'search',
                              placeholder:
                                'Search by Dealership, Owner, Form Number or Mobile No.',
                            }}
                            onChange={handleSearchChange}
                            value={userQuery}
                          />
                          <FilterButton
                            onClick={handleFilterBtnClick}
                            className={
                              filterbtnActive ? 'activeFilterBtn' : 'inActiveFilterBtn'
                            }
                          />
                        </div>
                        <img
                          src={excelImg}
                          alt='excel'
                          width={35}
                          height={35}
                          className='excelIcon'
                          onClick={() => handleExcelSheet(territoryId)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      {/* card Block */}
                      {dealerData && dealerData.length > 0 ? (
                        <Row>
                          <Col xs={12}>
                            {dealerData.map((elem, index) => {
                              return (
                                <DealerCodeCard
                                  onClick={() => handleCardClick(elem.id)}
                                  handleSAPExcel={() => handleSAPExcel(elem.id)}
                                  show={show === elem.id}
                                  elem={elem}
                                  key={index}
                                  getDealerListData={getDealerListData}
                                  cardClassName={'blueText'}
                                />
                              );
                            })}
                          </Col>
                          <Col xs={12}>
                            <div className='paginationWrapper'>
                              <span className='page-select-title'>Rows per page:</span>
                              &nbsp;&nbsp;
                              <select
                                className='form-control rows-per-page-select'
                                name='pageSize'
                                value={pageSize}
                                onChange={(e) => handleInputChange(e)}
                              >
                                <option key='5' value='5'>
                                  5 Rows
                                </option>
                                <option key='10' value='10'>
                                  10 Rows
                                </option>
                                <option key='15' value='15'>
                                  15 Rows
                                </option>
                                <option key='20' value='25'>
                                  25 Rows
                                </option>
                                <option key='25' value='30'>
                                  30 Rows
                                </option>
                                <option key='30' value='50'>
                                  50 Rows
                                </option>
                              </select>
                              &nbsp;&nbsp;
                              <div className='pageList'>
                                <Pagination
                                  margin={2}
                                  page={page}
                                  count={parseInt(totalPages)}
                                  pageSize={pageSize}
                                  totalRecords={parseInt(count)}
                                  onPageChange={handlePageChange}
                                ></Pagination>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <Row>
                          <Col xs={12}>
                            {messages.COMMON.NO_RECORD_MATCH}
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Container>
              </div>
              {/* Filter Modal */}
              <Modal
                isOpen={showFilterModal}
                toggle={() => setShowFilterModal(!showFilterModal)}
                centered
                className='dealerFilterModal'
                id='dealerFilterModal'
              >
                <ModalBody className='p-0'>
                  <div className='ModalArea'>
                    <Container>
                      <Row>
                        <Col xs={12}>
                          <div className='modalHeading'>
                            <div className='title'>Filter</div>
                            <div className='closeButton'>
                              <img
                                src={closeImg}
                                alt='close'
                                onClick={() => setShowFilterModal(!showFilterModal)}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Form onSubmit={handleApplyFilter}>
                            <FormGroup>
                              <Label className='common-input-label'>
                                Territory<span className='required'>*</span>
                              </Label>
                              <SingleSelect
                                // disabled={editId}
                                id='territoryType'
                                required={true}
                                name='territoryType'
                                value={
                                  territoryVal === null || territoryVal === 'undefined'
                                    ? ''
                                    : territoryVal
                                }
                                onChange={(e) => handleChangeTerritory(e)}
                                options={territoryData}
                                label={'name'}
                                selectedValueKey={'id'}
                              />
                            </FormGroup>
                            <div className='btnGroup'>
                              <CommonButton
                                name='Reset'
                                onClick={handleResetFilter}
                                btnClass={'btnSecondary'}
                                type='button'
                              />
                              <CommonButton
                                name='Apply'
                                btnClass={'btnPrimary'}
                                type='submit'
                              />
                            </div>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </ModalBody>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssignDealerCode;
